import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects"
import { adminGetNdaAgreementAPI } from "./api";
import { ADMIN_GET_NDA_AGREEMENT } from "./constants";
import { adminGetNdaAgreementFailed, adminGetNdaAgreementSuccess } from "./actions";

function* adminGetNdaAgreementAsync() {
    try {
        const response = yield call(adminGetNdaAgreementAPI)
        if (response && response.data.status === 1) {
            yield put(adminGetNdaAgreementSuccess(response.data.data ||[]))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(adminGetNdaAgreementFailed(error.response.data.error || "Unable to Get Agreements"))
    }
}


function* AdminNdaAgreementSaga() {
    yield takeEvery(ADMIN_GET_NDA_AGREEMENT, adminGetNdaAgreementAsync)
}

export default AdminNdaAgreementSaga;